import styled from 'styled-components';
import ReactFlow from 'reactflow';
import { ROW_HEIGHT, VIEW_NODE_WIDTH } from './utils';
import { theme } from '../../../../styles/theme';
import {
  floatingComponentStyles,
  level1Content,
} from '../../../../styles/shareableStyles';
import { SecondaryButton } from '../../../../components/Button';

export const StyledReactFlow = styled(ReactFlow)`
  min-height: 800px;
  // XXX make the nag link invisible
  .react-flow__attribution {
    display: none;
  }
  .react-flow__controls {
    ${floatingComponentStyles};
  }
  .react-flow__controls-button {
    border-bottom-color: ${theme.colors.border};
    font: inherit;
    background: unset;
    color: ${theme.colors.secondary600};
    > svg {
      fill: ${theme.colors.secondary600};
    }
    &:not(:disabled):hover {
      color: ${theme.colors.mainBlue};
      > svg {
        fill: ${theme.colors.mainBlue};
      }
    }
    &:last-child {
      border-bottom: none;
    }
  }
`;

export const ReactFlowNode = styled.div`
  padding: 5px;
  width: ${VIEW_NODE_WIDTH}px;
  ${level1Content};
  color: ${theme.colors.secondary900};
  .react-flow__handle {
    width: 8px;
    height: 10px;
    border-radius: 3px;
  }
`;

// XXX - 12 comes from ReactFlowNode padding (2 * 5) + borders (2 * 1)
const VIEW_TABLE_WIDTH = VIEW_NODE_WIDTH - 12;

export const FieldsTable = styled.div`
  display: table;
  width: ${VIEW_TABLE_WIDTH}px;
  table-layout: fixed;
  margin-top: 6px;
`;

export const FieldRow = styled.div`
  padding: 0;
  margin: 0;
  white-space: nowrap;
  display: table-row;
  div {
    border-left: 1px solid ${theme.colors.border};
    border-bottom: 1px solid ${theme.colors.border};
  }
`;

export const FieldHeader = styled(FieldRow)`
  border-top: 1px solid ${theme.colors.border};
  border-left: 1px solid ${theme.colors.border};
  display: table-header-group;
  background-color: ${theme.colors.tableHeader};
  div {
    border-top: 1px solid ${theme.colors.border};
  }
`;

export const FieldProp = styled.div`
  max-height: ${ROW_HEIGHT}px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
  margin: 0;
  display: table-cell;
  text-align: center;
  font-size: 10px;
`;

export const FieldTableFieldsRow = styled(FieldRow)`
  display: table-caption;
  border-left: 1px solid ${theme.colors.border};
  border-right: 1px solid ${theme.colors.border};
  width: ${VIEW_NODE_WIDTH - 12}px;
  padding-left: 4px;
  padding-right: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 10px;
`;

export const FieldPropClass = styled(FieldProp)<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  color: ${theme.colors.secondary900};
`;

export const FieldPropHeader = styled(FieldProp)<{ $widthPercent: number }>`
  font-weight: 600;
  width: ${({ $widthPercent }) => `${$widthPercent}%`};
`;

export const ViewHeaderDiv = styled.div`
  text-align: center;
  font-weight: 600;
  padding: 8px 16px;
`;

export const ViewTablesWrapperDiv = styled.div`
  div {
    border-top: 1px solid ${theme.colors.border};
    border-left: 1px solid ${theme.colors.border};
    border-right: 1px solid ${theme.colors.border};
  }
  div:last-child {
    border-bottom: 1px solid ${theme.colors.border};
  }
`;

export const ViewSection = styled.div`
  width: 100%;
  margin-top: 4px;
`;

export const ViewRowDiv = styled.div`
  max-height: ${ROW_HEIGHT}px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 8px 4px;
`;

export const ViewHeaderTableRow = styled(ViewRowDiv)`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const ExpandCollapseButtonDiv = styled(SecondaryButton)`
  width: 100%;
  margin-top: 8px;
`;
